import {computed, inject, Injectable, signal} from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {
  CustomerProductHistorySummary,
  CustomerProductService,
  CustomerProductSummary,
} from '../../../../../../api';
import {QueryKey} from '../../../../../constants/query-key';
import {isOneShotProduct} from '../customer-product.utils';

@Injectable()
export class CustomerProductQueryService {
  private readonly customerProductService = inject(CustomerProductService);

  customerId = signal<number | null>(null);

  customerProductsQuery = injectQuery(() => ({
    queryKey: [QueryKey.PRODUCT_CUSTOMERS, this.customerId()],
    queryFn: () => lastValueFrom(this.customerProductService.getCustomerProductsByCustomerId(this.customerId()!)),
    enabled: this.customerId() !== null,
  }));

  historyQuery = injectQuery(() => ({
    queryKey: [QueryKey.PRODUCT_CUSTOMER_HISTORY, this.customerId()],
    queryFn: () =>
      lastValueFrom(this.customerProductService.getCustomerProductHistoryByCustomerId(this.customerId()!)),
    enabled: this.customerId() !== null,
  }));

  productCustomers = computed<CustomerProductSummary[]>(() => this.customerProductsQuery.data()?.customerProducts ?? []);
  isLoading = computed(() => this.customerProductsQuery.isLoading());

  // Already sorted most recent first by the back.
  history = computed<CustomerProductHistorySummary[]>(() => this.historyQuery.data()?.history ?? []);
  isHistoryLoading = computed(() => this.historyQuery.isLoading());

  recurringProducts = computed<CustomerProductSummary[]>(() =>
    this.productCustomers().filter(product => !isOneShotProduct(product)));

  oneShotProducts = computed<CustomerProductSummary[]>(() =>
    this.productCustomers().filter(product => isOneShotProduct(product)));
}
